import { API_URL } from 'lib/shared/consts'

import { NotFoundError, RequestError, UnauthorizedError } from './errors'
import { snakeToCamelCase } from './utils/snakeToCamelCase'

export async function request<T = void>(
  path: string,
  {
    payload,
    init = {},
    convertToCamelCase = false,
  }: { payload?: unknown; init?: RequestInit; convertToCamelCase?: boolean } = {},
) {
  const response = await fetch(`${API_URL}${path}`, {
    method: init.method ?? 'get',
    credentials: init.credentials ?? 'include',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      ...init.headers,
    },
    body: typeof payload !== 'undefined' ? JSON.stringify(payload) : undefined,
  })

  switch (response.status) {
    case 401:
      throw new UnauthorizedError('Unauthorized error on request')

    case 404: {
      let cause: string | undefined

      try {
        cause = (await response.json())?.detail
      } catch {
        /**
         * We attempt to parse the response to look for the `detail` property.
         * If the property is not found or there is an error in parsing,
         * it is not considered an issue.
         */
      }

      throw new NotFoundError('Not found error on request', {
        cause,
      })
    }
  }

  if (!response.ok) {
    throw new RequestError(`Unable to fetch data on "${path}"`)
  }

  const data = await response.json()

  if (convertToCamelCase) {
    snakeToCamelCase(data)
  }

  return data as T
}
